var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cart-view",
      class: { "cart-view--checkout": _vm.checkoutView },
    },
    [
      _c(
        "div",
        { staticClass: "grid" },
        [
          _vm.loading || _vm.initializing
            ? [_c("spinner")]
            : [
                _c(
                  "div",
                  {
                    staticClass: "grid__item tickets tickets--cart",
                    class: {
                      "grid__item--100": !this.allowCodeInput,
                      "grid__item--65": this.allowCodeInput,
                    },
                  },
                  [
                    _vm.ticketConfigurations.length === 0
                      ? [_c("p", [_vm._v(_vm._s(_vm.$t("cart.empty")))])]
                      : [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("cart.productsHint", [
                                  _vm.totalProductCount,
                                ])
                              )
                            ),
                          ]),
                        ],
                    _vm._v(" "),
                    _vm.checkoutView
                      ? [
                          _vm._l(
                            _vm.computedEditableTicketConfigurationsByEvent,
                            function (ticketConfigurations, eventId) {
                              return [
                                _c("h3", { staticClass: "cart__headline" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.eventLookup[eventId]
                                        .descriptionExternal
                                    ) +
                                      " (" +
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.eventLookup[eventId]
                                            .eventDateStart,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.eventLookup[eventId].eventDateEnd,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ticket-summary" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ticket ticket__headline",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "ticket__description",
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "ticket__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "cart.headers.ticket"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ticket__slot" },
                                          [
                                            _vm.isTimeSlotVisible
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "ticket__title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "cart.headers.slots"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ticket__amount" },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "ticket__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "cart.headers.quantity"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ticket__price" },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "ticket__title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("cart.headers.price")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.checkoutView
                                          ? _c("div", {
                                              staticClass:
                                                "ticket__interaction",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      ticketConfigurations,
                                      function (ticketConfiguration) {
                                        return [
                                          _c("cart-item", {
                                            key: ticketConfiguration.id,
                                            class: {
                                              "ticket--special":
                                                ticketConfiguration.specialProduct,
                                            },
                                            attrs: {
                                              language: _vm.userLanguage,
                                              "inventory-url": _vm.inventoryUrl,
                                              "ticket-configuration":
                                                ticketConfiguration,
                                              "checkout-view": _vm.checkoutView,
                                              readonly: _vm.readonly,
                                            },
                                            on: {
                                              setQuantity:
                                                _vm.setConfigQuantity,
                                              updateCart: _vm.updateCart,
                                            },
                                          }),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            }
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "ticket ticket__headline" },
                            [
                              _c(
                                "div",
                                { staticClass: "ticket__description" },
                                [
                                  _c("p", { staticClass: "ticket__title" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("cart.headers.ticket"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "ticket__slot" }, [
                                _vm.isTimeSlotVisible
                                  ? _c("p", { staticClass: "ticket__title" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("cart.headers.slots"))
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ticket__amount" }, [
                                _c("p", { staticClass: "ticket__title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("cart.headers.quantity"))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ticket__price" }, [
                                _c("p", { staticClass: "ticket__title" }, [
                                  _vm._v(_vm._s(_vm.$t("cart.headers.price"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.checkoutView
                                ? _c("div", {
                                    staticClass: "ticket__interaction",
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.computedEditableTicketConfigurations,
                            function (ticketConfiguration, key) {
                              return [
                                _c("cart-item", {
                                  key: ticketConfiguration.id,
                                  class: {
                                    "ticket--special":
                                      ticketConfiguration.specialProduct,
                                  },
                                  attrs: {
                                    language: _vm.userLanguage,
                                    "inventory-url": _vm.inventoryUrl,
                                    "ticket-configuration": ticketConfiguration,
                                    "checkout-view": _vm.checkoutView,
                                    readonly: _vm.readonly,
                                  },
                                  on: {
                                    setQuantity: _vm.setConfigQuantity,
                                    updateCart: _vm.updateCart,
                                  },
                                }),
                                _vm._v(" "),
                                ticketConfiguration.subTicketConfigurations
                                  .length > 0
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ticket__cartSubCartItems",
                                        },
                                        [
                                          _vm._l(
                                            ticketConfiguration.subTicketConfigurations,
                                            function (subConf, innerKey) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ticket__cartSubCartItem",
                                                  },
                                                  [
                                                    _c("cart-item", {
                                                      key: subConf.id,
                                                      class: {
                                                        "ticket--special":
                                                          subConf.specialProduct,
                                                      },
                                                      attrs: {
                                                        language:
                                                          _vm.userLanguage,
                                                        "inventory-url":
                                                          _vm.inventoryUrl,
                                                        "ticket-configuration":
                                                          subConf,
                                                        "checkout-view":
                                                          _vm.checkoutView,
                                                        readonly: _vm.readonly,
                                                      },
                                                      on: {
                                                        setQuantity:
                                                          _vm.setSubConfigQuantity,
                                                        updateCart:
                                                          _vm.updateCart,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                    _vm._v(" "),
                    _vm.cart && _vm.cart.cartPromotions.length
                      ? [
                          !_vm.checkoutView
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "ticket__cartPromotionHeadline h3",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("cart.promotionCodes")) + ":"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.cart.cartPromotions,
                            function (promotionCode) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "ticket ticket--promotion" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ticket__description ticket__description--big",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ticket__descriptionTitle ticket__descriptionTitle--big",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("cart.promotionCode")
                                                ) +
                                                " (" +
                                                _vm._s(_vm.$t("cart.code")) +
                                                ": " +
                                                _vm._s(promotionCode.code) +
                                                ")\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "ticket__price" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ticket__priceAmount",
                                          },
                                          [
                                            _vm._v(
                                              "- " +
                                                _vm._s(
                                                  promotionCode.discountValue
                                                ) +
                                                " " +
                                                _vm._s(
                                                  promotionCode.discountType
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.checkoutView
                                      ? _c("div", {
                                          staticClass: "ticket__interaction",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            }
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    false
                      ? [
                          _c(
                            "div",
                            { staticClass: "ticket ticket--noBorder" },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _vm.checkoutView
                                ? _c("div", {
                                    staticClass: "ticket__interaction",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ticket ticket--noBorder ticket--sum",
                        class: { "space-above": _vm.amountEventsInCart > 1 },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ticket__description ticket__description--big",
                          },
                          [
                            _c("p", { staticClass: "ticket__title" }, [
                              _vm._v(_vm._s(_vm.$t("cart.totalSum")) + ":"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ticket__price ticket__sum" },
                          [
                            _vm.cart
                              ? [
                                  _c("p", { staticClass: "ticket__title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatPrice")(_vm.cart.sum)
                                      ) + " €"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "ticket__subTitle" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$t("cart.cartItem.includingVat")
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.checkoutView
                          ? _c("div", { staticClass: "ticket__interaction" })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.checkoutView
                      ? _c(
                          "div",
                          { staticClass: "cart__buttonWrapper" },
                          [
                            _vm.checkingQuantity
                              ? [_c("spinner")]
                              : [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "button",
                                      attrs: { href: _vm.ticketShopUrl },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("cart.goBack")))]
                                  ),
                                  _vm._v(" "),
                                  _vm.loggedIn
                                    ? [
                                        _vm.canCheckout
                                          ? [
                                              _vm.isGuest
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "button button-inverted",
                                                      attrs: {
                                                        href: _vm.loginPageUrl,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "cart.continue"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "button button-inverted",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          $event.preventDefault()
                                                          return _vm.checkOrderQuantity.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "cart.continue"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    : _c(
                                        "a",
                                        {
                                          staticClass: "button button-inverted",
                                          attrs: { href: _vm.loginPageUrl },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("cart.continue"))
                                          ),
                                        ]
                                      ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
          _vm._v(" "),
          !_vm.checkoutView
            ? _c(
                "div",
                {
                  staticClass:
                    "grid__item grid__item--35 grid__item--last ticketCode",
                },
                [
                  _c(
                    "div",
                    [
                      _vm.allowCodeInput
                        ? [
                            _c("div", { staticClass: "ticketCode__box" }, [
                              _c("div", { staticClass: "input" }, [
                                _c(
                                  "p",
                                  { staticClass: "h3 ticketCode__boxHeadline" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("cart.ticketCode.headline"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "ticketCode__boxText",
                                    attrs: { for: "promotionCode" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("cart.ticketCode.subHeadline")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "form",
                                  {
                                    staticClass:
                                      "ticketCode__boxInput form__group form__group--input",
                                    on: {
                                      submit: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.redeemCode.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.newUserCode,
                                          expression: "newUserCode",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass:
                                        "ticketCode__boxInputElement input input--input",
                                      attrs: {
                                        id: "promotionCode",
                                        type: "text",
                                      },
                                      domProps: { value: _vm.newUserCode },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.newUserCode =
                                            $event.target.value.trim()
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.newUserCodeError &&
                                _vm.newUserCode.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("cart.ticketCode.usedCode", [
                                            _vm.newUserCode,
                                          ])
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.newUserCodeIsPromotion &&
                                _vm.newUserCode.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "cart.ticketCode.codeIsRegistrationOrAdvertising",
                                            [_vm.newUserCode]
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "ticketCode__boxButton button",
                                    attrs: { disabled: _vm.readonly },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.redeemCode.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("cart.ticketCode.redeemCode")
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "payment__images" },
                      [
                        _vm._l(_vm.paymentChoices, function (payment) {
                          return [
                            payment.value === "creditcard"
                              ? [
                                  _c("img", {
                                    staticClass: "mastercard",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/mastercard.png",
                                      alt: "mastercard",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "visa",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/visa.png",
                                      alt: "visa",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "paypal"
                              ? [
                                  _c("img", {
                                    staticClass: "paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paypal.png",
                                      alt: "paypal",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "sepa"
                              ? [
                                  _c("img", {
                                    staticClass: "paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/SepaLogo.svg",
                                      alt: "sepa",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            payment.value === "paydirekt"
                              ? [
                                  _c("img", {
                                    staticClass: "giropay paypal",
                                    attrs: {
                                      src: "https://www.messe-stuttgart.de/fileadmin/media/mts/payment/paydirekt.svg",
                                      alt: "paydirekt",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ticketList-agb-privacy" },
                      [
                        _vm._l(_vm.events, function (event) {
                          return [
                            _c(
                              "div",
                              { staticClass: "ticketList-agb-privacy__box" },
                              [
                                _vm.ticketConfigurations.length > 1
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ticket__descriptionTitle privacyStatement__descriptionTitle",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "privacy.headlineClient",
                                                  {
                                                    eventsTitle:
                                                      event.descriptionExternal,
                                                  }
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "privacyStatement" },
                                  [
                                    _vm.privacyStatements["" + event.clientId]
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "inline-link privacyStatement-link",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.openPrivacyModal(
                                                    event.clientId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "privacy.client.privacyStatement2"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "inline-link privacyStatement-link",
                                              attrs: {
                                                target: "_blank",
                                                href: _vm.i18nPrivacyStatementLink,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "privacy.client.privacyStatement2"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "privacyStatement" },
                                  [
                                    _vm.agb["" + event.clientId]
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "inline-link privacyStatement-link",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.openAGBModal(
                                                    event.clientId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("privacy.agb.agbOf")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "privacyStatement-link",
                                              attrs: {
                                                target: "_blank",
                                                href: _vm.i18nTermsAndConditionsLink,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("privacy.agb.agbOf")
                                                  )
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              2
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "Modal",
                    { ref: "privacyModal" },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _vm.allPrivacyStatements[_vm.selectedClient]
                            ? [
                                _c("div", {
                                  staticClass: "privacyModal",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.i18nPrivacyStatementContent
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "Modal",
                    { ref: "agbModal" },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _vm.allAGBs[_vm.selectedClient]
                            ? [
                                _c("div", {
                                  staticClass: "privacyModal",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.i18nTermsAndConditionsContent
                                    ),
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ticket__description ticket__description--big" },
      [
        _c(
          "p",
          {
            staticClass:
              "ticket__descriptionTitle ticket__descriptionTitle--big",
          },
          [_vm._v("Versandkosten")]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "ticket__descriptionSubtitle" }, [
          _vm._v(
            "Es werden keine Versandkosten anfallen. Die Tickets werden in digitaler Form bereitgestellt."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ticket__price" }, [
      _c("p", { staticClass: "ticket__title ticket__title--light" }, [
        _vm._v("0,00 €"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }